// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__pUAjL","footer":"ModalFilter_footer__1tNK_"};